module.exports = __webpack_public_path__ + "img/florist.fe6c9058.png";